import { AuthenticationService } from './services/auth.service'
import { ContextService } from './services/context.service'
import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { Subscription } from 'rxjs'
import { environment } from '../environments/environment'
import { ActivatedRoute, Router } from '@angular/router'
import mapboxgl from 'mapbox-gl'

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  @HostBinding('style.display') hostDisplay = 'flex'

  private subscription: Subscription
  isPrinting = true

  constructor(
    private translate: TranslateService,
    private context: ContextService,
    private auth: AuthenticationService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    const availableLangs = environment.availableLangs || ['en', 'es']
    translate.addLangs(availableLangs)
    translate.setDefaultLang('en')

    context.init()

    mapboxgl.workerCount = 4
    mapboxgl.prewarm()
    this.subscription = this.auth.changes.subscribe(() => {
      this.checkAuth()
    })
    setTimeout(() => {
      this.subscription.add(
        this.route.queryParams.subscribe((params) => {
          if (params['lang']) {
            this.translate.use(params['lang'])
            window.localStorage.setItem('language', params['lang'])
          } else {
            const selectedLang = window.localStorage.getItem('language')

            if (selectedLang && availableLangs.indexOf(selectedLang) !== -1) {
              this.translate.use(selectedLang)
            } else {
              const browserLang = this.translate.getBrowserLang()
              if (browserLang && availableLangs.indexOf(browserLang) !== -1) {
                this.translate.use(browserLang)
              }
            }
          }
        }),
      )
    })
  }

  ngOnInit() {
    console.info(
      '%cVodafone %cAnalytics %cis running',
      'color: red; font-weight: bold;',
      'color: black; font-weight: bold;',
      'color: black;',
    )
    this.subscription.add(
      this.context.isPrinting.subscribe((value) => {
        this.isPrinting = value
        setTimeout(() => {
          this.hostDisplay = this.isPrinting ? 'block' : 'flex'
        })
      }),
    )
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }

    mapboxgl.clearPrewarmedResources()
  }

  isLoggedIn() {
    return this.auth.isLoggedIn()
  }

  checkAuth() {
    if (!this.isLoggedIn()) {
      this.router.navigateByUrl('/login')
    }
  }
}
